import { ApiErrorTranslationKeys } from '@/lib/api/apiErrorTranslationKeys.ts';
import { isKnownBackendErrorKey } from '@/lib/api/exception.ts';

/**
 * Backend `TranslationKey` enum member name — see `hasErrorKey` for why the
 * dotted variant (`error.cost_category.name_taken`) never matches.
 */
const NAME_TAKEN: keyof typeof ApiErrorTranslationKeys =
  'COST_CATEGORY_NAME_TAKEN';

/**
 * Zwraca komunikat o zajętej nazwie, żeby formularz mógł go pokazać pod polem
 * `name` zamiast zostawiać operatora z samym toastem.
 */
export const getCostCategoryNameTakenMessage = (
  error: unknown,
): string | undefined =>
  isKnownBackendErrorKey(error, NAME_TAKEN)
    ? ApiErrorTranslationKeys[NAME_TAKEN]
    : undefined;

const MERGE_FIELD_KEYS: (keyof typeof ApiErrorTranslationKeys)[] = [
  'COST_CATEGORY_MERGE_INTO_ITSELF',
  'COST_CATEGORY_ARCHIVED',
  'COST_CATEGORY_NOT_FOUND',
];

/** Błędy scalania dotyczą wybranego celu, więc mają stanąć pod tym polem. */
export const getCostCategoryMergeMessage = (
  error: unknown,
): string | undefined => {
  const key = MERGE_FIELD_KEYS.find((candidate) =>
    isKnownBackendErrorKey(error, candidate),
  );
  return key ? ApiErrorTranslationKeys[key] : undefined;
};
